export class SelectItem {
  id: any;
  name: string;
  parentId?: any;
  alias?: string;//Newly Added for Config and Filter screens, ? means optional - IMP
  origName?: string;
  children?: any[];
  showSubUL?: number;
}
